import { render, staticRenderFns } from "./cardItemHeader.vue?vue&type=template&id=2134b46d&scoped=true"
import script from "./cardItemHeader.vue?vue&type=script&lang=js"
export * from "./cardItemHeader.vue?vue&type=script&lang=js"
import style0 from "./cardItemHeader.vue?vue&type=style&index=0&id=2134b46d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134b46d",
  null
  
)

export default component.exports